<template>
  <v-card>

    <!-- titulo y botonera principal -->
    <v-card-title class="buttonBar">
      <div style='width:100% '>

        <!-- titulo pagina -->
        <div class="headline" style="float: left;padding-left:10px;">
          {{ $t('listaPresupuestos') }}
        </div>

        <!-- botonera -->
        <div style="float: right;">
          <v-btn id="newPresupuesto" color="green darken-1 white--text" @click="fMuestraResumenPresupuesto">
            <v-icon>mdi-pencil</v-icon>
            <span>{{ $t('editar') }}</span>
          </v-btn>
          <v-btn id="newPresupuesto" color="green darken-1 white--text" @click="fNuevoPresupuesto">
            <v-icon>mdi-plus</v-icon>
            <span>{{ $t('nuevo') }}</span>
          </v-btn>
          <v-btn id="deletePresupuesto" color="green darken-1 white--text" @click="fCheckBorradoPresupuestos">
            <v-icon>mdi-delete</v-icon>
            <span>{{ $t('borrar') }}</span>
          </v-btn>
          <v-btn id="seachFilters" color="green darken-1 white--text" @click="fOpenFilters">
            <v-icon>mdi-filter-variant-plus</v-icon>
            <span>{{ $t('advancedFilters') }}</span>
          </v-btn>
        </div>

      </div>
      <v-layout v-if="dActiveFilter" row wrap>
        <v-flex xs12 ml-3 mr-3>
          <v-layout row wrap>
            <v-flex md12 px-2>
              <label>{{ $t("aplicarFiltrosYcomenzar") }}</label>
            </v-flex>
            <v-flex md3 px-2>
              <v-menu :ref="dDatosFiltros.fechaIniMenu" lazy v-model="dDatosFiltros.fechaIniMenu"
                transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px"
                :close-on-content-click="false">
                <v-text-field required clearable color="data-colorcorp1" slot="activator" :label="$t('fechaInicial')"
                  v-model="dDatosFiltros.fechaIniString" append-icon="event" readonly></v-text-field>
                <v-date-picker required :min="dDatosFiltros.fechaMinIni" clearable v-model="dDatosFiltros.fechaIni"
                  no-title scrollable :first-day-of-week="1" locale="es-es"
                  @input="fGetFecha(dDatosFiltros.fechaIni, 'ini')"></v-date-picker>
              </v-menu>
              <v-menu :ref="dDatosFiltros.fechaFinMenu" lazy v-model="dDatosFiltros.fechaFinMenu"
                transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px"
                :close-on-content-click="false">
                <v-text-field required clearable color="data-colorcorp1" slot="activator" :label="$t('fechaFinal')"
                  v-model="dDatosFiltros.fechaFinString" append-icon="event" readonly></v-text-field>
                <v-date-picker required :min="dDatosFiltros.fechaMinFin" clearable v-model="dDatosFiltros.fechaFin"
                  no-title scrollable :first-day-of-week="1" locale="es-es"
                  @input="fGetFecha(dDatosFiltros.fechaFin, 'fin')"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex md3 px-2>
              <v-text-field :label="$t('numPresu')" v-model="dDatosFiltros.numPedido"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md12 px-2>
              <label>{{ $t("filtroClient") }}</label>
            </v-flex>
            <v-flex md6 px-2>
              <DatTextFieldCode :pDataPass="dDataClient" @select="fSelectClient" @alert="fAlert" @clean="fCleanClient">
              </DatTextFieldCode>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md12 px-2 ml-auto>
              <v-layout justify-end>
                <v-btn small flat class="datSecondaryBtn" @click="fSearch">{{ $t('buscar') }}</v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-title>

    <!-- tabla visualización datos -->

    <DataTablePresupuestos ref="TablaPresupuestos" :pData="dDataTable" @recharge="fCargarListado"
      @selectItem="fSelectPresupuesto" @selectAll="fSelectAllPres"></DataTablePresupuestos>

    <!-- comprobacion borrado -->
    <v-dialog v-model="dMostrarAlertaBorrado" persistent max-width="370">
      <v-card>
        <v-card-title class="subheading" style="text-align: center; padding: 25px 15px;">{{
          $t('checkBorradoPresupuestos') }}</v-card-title>
        <v-card-actions style="background-color: #eee;padding: 15px">
          <v-spacer></v-spacer>
          <v-btn color="green darken-1  white--text" @click="dMostrarAlertaBorrado = false">{{ $t('no') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1  white--text" @click="fBorradoPresupuestos(); dMostrarAlertaBorrado = false">{{
            $t('si') }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
import DataTablePresupuestos from '@/components_datadec/DataTablePresupuestos'
import DatTextFieldCode from '@/components_datadec/DatTextFieldCode'

// SERVICE

import SrvPres from '@/services/srv-presupuestos'

const ORIGEN_LISTADO = 'listado'

export default {
  components: {
    DatTextFieldCode,
    DataTablePresupuestos
  },
  props: {
    pLimitDate: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data() {
    return {
      dDatosFiltros: {
        'numPedido': '',
        'cliente': '',
        'estado': 'T',
        'fechaIni': null,
        'fechaIniString': '',
        'fechaIniMenu': null,
        'fechaMinIni': '',
        'fechaFin': null,
        'fechaFinString': '',
        'fechaFinMenu': null,
        'fechaMinFin': '',
        'idCliente': '',
        'centroTrabajo': ''
      },
      dFormatDate: {
        'default': 'DD/MM/YYYY',
        'years': 'YYYY-MM-DD'
      },
      dDataClient: {},
      dActiveFilter: false,
      dDataTableId: 'LISTADO',
      dMostrarAlertaBorrado: false,
      dLoading: true,
      dPagination: {
        rowsPerPage: 10
      },
      dSelectClientIni: {},
      dRequestClient: { empresa: this.$store.getters.getAutenticacion.empresa },
      dUrlClients: 'lovClte',
      dPresupuestosSeleccionados: [],
      dSortBy: 'fechaCreacion',
      dDescending: true,
      dDataTable: {
        'headers': [
          { text: this.$t('numeroPresupuesto'), align: 'left', value: 'numeroPedido', column: 'numeroPedido' },
          { text: this.$t('cliente'), align: 'center', value: 'cliente', column: 'cliente' },
          { text: this.$t('sucursal'), align: 'center', value: 'sucursalEnvio', column: 'sucursalEnvio' },
          { text: this.$t('razonSocial'), align: 'left', value: 'razonSocial', column: 'razonSocial' },
          { text: this.$t('fecha'), align: 'center', value: 'fechaCreacion', column: 'fechaCreacion' },
          { text: this.$t('importe'), align: 'right', value: 'importePedidoEntrado', column: 'importePedidoEntrado' },
          { text: this.$t('fechaVigencia'), align: 'center', value: 'fechaVigencia', column: 'fechaVigencia' },
          { text: this.$t('estado'), align: 'right', value: 'nombreEstado', column: 'nombreEstado' }
        ],
        'items': [],
        'initSearch': '',
        'totalItems': 0,
        'checkboxOn': true,
        'rowsPerPage': 10,
        'loading': false,
        'isVisible': true,
        'descending': 'ASC',
        'sortBy': 'fechaVigencia',
        'search': false,
        'page': 1,
        'isSearch': false
      },
      filters: null
    }
  },
  created() {
    this.fIniciarVariables()
    this.fSearch()
  },
  computed: {
    cRoleUser() {
      return this.dRole
    }
  },
  methods: {
    fSelectPresupuesto(presupuesto) {
      this.$nextTick(() => {
        if (!this.dPresupuestosSeleccionados.includes(presupuesto)) {
          this.dPresupuestosSeleccionados.push(presupuesto)
        } else {
          const index = this.dPresupuestosSeleccionados.indexOf(presupuesto)
          if (index > -1) {
            this.dPresupuestosSeleccionados.splice(index, 1)
          }
        }
      })
    },
    fSelectAllPres(presupuestos) {
      this.dPresupuestosSeleccionados = presupuestos
    },
    fCargarListado(parametros) {
      this.fSearch(parametros.sortBy, parametros.descending, parametros.page, parametros.rowsPerPage, parametros.search, parametros.filters)
    },
    fIniciarVariables() {
      this.dDataClient = {
        'errorMessages': [],
        'label': 'clienteInicial',
        'rowsPerPage': 10,
        'headers': [
          { text: this.$t('cliente'), align: 'left', value: 'codigo', column: 'cliente' },
          { text: this.$t('nombreCliente'), align: 'left', value: 'nombre', column: 'nombre' }
        ],
        'urlWS': this.dUrlClients,
        'item': { 'codigo': '', 'nombre': '' },
        'filters': { 'codigo': 'cliente', 'nombre': 'nombre' },
        'resultName': 'dataRes',
        'request': this.dRequestClient,
        'default': this.dSelectClientIni,
        'disabled': false,
        'required': false,
        'orderByDefault': 'cliente',
        'orderDefault': 'ASC',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': 'seleccionaUnCliente'
      }
      this.dRole = this.pLimitDate.roleUser
      this.dPresupuestosSeleccionados = []
    },

    fSelectClient(item) {
      if (item && item != null) {
        this.dSelectClientIni.codigo = item.codigo
        this.dSelectClientIni.nombre = item.nombre
        this.dDatosFiltros.idCliente = item.codigo
      }
    },
    fCleanClient() {
      this.dSelectClientIni = {}
    },
    /*
     * Comprueba si puede borrar
     */
    fCheckBorradoPresupuestos() {
      // Comprueba si se ha seleccionado algo
      if (this.dPresupuestosSeleccionados && this.dPresupuestosSeleccionados.length > 0) {
        this.dMostrarAlertaBorrado = true
      } else {
        this.$bus.$emit('evento-mostrarAvisos', this.$t('noSeleccion'))
      }
    },
    fGetFecha(val, tipo) {
      switch (tipo) {
        case 'ini':
          this.dDatosFiltros.fechaIniString = this.$moment(val, this.dFormatDate.years).format(this.dFormatDate.default)
          this.dDatosFiltros.fechaIniMenu = false
          break
        case 'fin':
          this.dDatosFiltros.fechaFinString = this.$moment(val, this.dFormatDate.years).format(this.dFormatDate.default)
          this.dDatosFiltros.fechaFinMenu = false
          break
      }
    },
    /*
     * Abre los filtros avanzados
     */
    fOpenFilters() {
      this.dActiveFilter = !this.dActiveFilter
    },
    /*
     * borra los presupuestos seleccionados / avisa si no hay ninguno
     */
    fBorradoPresupuestos() {
      promise.push(this.dPresupuestosSeleccionados.map((item) => {
        // borrar presupuestos
        const payload = {
          usuario: this.$store.getters.getAutenticacion.usuario,
          tira: this.$store.getters.getAutenticacion.tira,
          empresa: this.$store.getters.getAutenticacion.empresa,
          cliente: item.cliente,
          numeroPedido: item.numeroPedido,
          numeroBis: item.numeroBis
        }
        return SrvPres.borrarPresupuesto(payload).then(response => {
            if (response.data.statusCode !== '200') {
              this.$emit('alert', '<b>' + this.$t('delPres') + '</b><br> ' + this.$t('delPresDesc'))
            }
          }).catch(error => {
            this.$emit('alert', '<b>' + this.$t('delPres') + '</b><br> ' + this.$t('delPresDesc'))
            console.error(error)
          })
      }))
      setTimeout(() => {
        Promise.all(promise).then(result => {
          this.$refs.TablaPresupuestos.fResetPage()
          this.dPresupuestosSeleccionados = []
          this.fSearch()
        })
      }, 200)
    },
    fAlert(msg) {
      this.$emit('alert', msg)
    },
    /*
     * muestra pagina resumen de un presupuesto
     */
    fMuestraResumenPresupuesto() {
      if (this.dPresupuestosSeleccionados.length === 1) {
        if (this.dPresupuestosSeleccionados[0].estado === 1) {
          this.$emit('goToResum', this.dPresupuestosSeleccionados[0], ORIGEN_LISTADO)
        } else {
          this.$emit('alert', this.$t('notStatusCorrect'))
        }
      } else if (this.dPresupuestosSeleccionados.length < 1) {
        this.$emit('alert', this.$t('noSeleccion'))
      } else {
        this.$emit('alert', this.$t('onePresupuesto'))
      }
    },
    /*
     * nuevo presupuesto
     */
    fNuevoPresupuesto() {
      const nuevoPresupuesto = {
        id: null,
        numeroPedido: null,
        nombre: null,
        cliente: null,
        sucursalEnvio: null,
        observaciones: null,
        razonSocial: null,
        fechaCreacion: null,
        importePedidoEntrado: null,
        estado: null,
        formaPago: null,
        representante: null,
        products: []
      }
      this.$emit('goToAsistente', nuevoPresupuesto, ORIGEN_LISTADO)
    },

    fSearch(sortBy, descending, page, rowsPerPage, search, filters) {
      this.dPresupuestosSeleccionados = []
      this.dFilters = filters
      let offset = 1
      let fechaFin = ''
      descending = (descending) ? 'DESC' : 'ASC'

      if (sortBy === undefined) {
        descending = 'DESC'
      }

      if (page === undefined) {
        page = 1
      }
      if (rowsPerPage === undefined) {
        rowsPerPage = this.dPagination.rowsPerPage
      }
      if (filters === undefined) {
        filters = []
      }

      offset = this.dPagination.rowsPerPage * (page - 1) + 1

      const codCliente = (this.dSelectClientIni.codigo !== undefined && this.dSelectClientIni.codigo !== '') ? this.dSelectClientIni.codigo : ''
      const fechaIni = (this.dDatosFiltros.fechaIniString !== undefined && this.dDatosFiltros.fechaIniString !== '') ? this.dDatosFiltros.fechaIniString : ''
      if (this.dDatosFiltros.fechaFinString !== undefined && this.dDatosFiltros.fechaFinString !== '') {
        const dateFin = new Date(this.$moment(this.dDatosFiltros.fechaFinString, this.dFormatDate.default).format(this.dFormatDate.years))
        dateFin.setDate(dateFin.getDate() + 1)
        fechaFin = dateFin.getDate() + '/' + (dateFin.getMonth() + 1) + '/' + dateFin.getFullYear()
      }
      const numPedido = (this.dDatosFiltros.numPedido !== undefined && this.dDatosFiltros.numPedido !== '') ? this.dDatosFiltros.numPedido : ''
      const payload = {
        usuario: this.$store.getters.getAutenticacion.usuario,
        tira: this.$store.getters.getAutenticacion.tira,
        empresa: this.$store.getters.getAutenticacion.empresa,
        search,
        offset,
        numRows: rowsPerPage,
        orderBy: 'fechaCreacion',
        order: descending,
        filters: filters,
        codCliente,
        fechaIni,
        fechaFin,
        numPedido
      }
      this.fCargaPresupuestos(payload)
    },
    /*
     * Metodo de carga de presupuestos
     */
    fCargaPresupuestos(payload) {
      this.dLoading = true
      this.dDataTable.items = []
      this.$emit('loading', '')
      SrvPres.getListadoPresupuestos(payload).then(response => {
        if (response.data.statusCode === '200') {
          const datosPresupuestos = response.data.presupuestos.map((value, index) => {
            return {
              'id': value.id,
              'numeroPedido': value.numeroPedido,
              'cliente': value.cliente,
              'sucursalEnvio': value.sucursalEnvio,
              'razonSocial': value.razonSocial,
              'fechaCreacion': value.fechaCreacion,
              'importePedidoEntrado': value.importePedidoEntrado,
              'fechaVigencia': value.fechaVigencia,
              'estado': value.estado,
              'numeroBis': value.numeroBis,
              'nombreEstado': value.nombreEstado
            }
          })
          this.dDataTable.items = datosPresupuestos
          if (response.data.totalRows !== undefined && response.data.totalRows !== null) {
            this.dDataTable.totalItems = response.data.totalRows
          } else {
            this.dDataTable.totalItems = response.data.numRegs
          }

          this.dLoading = false
        } else {
          this.$emit('alert', '<b>carga presupuestos</b><br> ' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
        this.$emit('loading', '')
      }).catch(error => {
        console.error(error)
        this.$emit('alert', '<b>carga presupuestos</b><br> ' + error.response.data.statusText)
        this.$emit('loading', '')
      })
    },
    /*
     * formatea un filtro de tipo rango
     */
    fFormateaValorFiltroRango(value) {
      const valuesArray = value
      let valuesString = ''
      if (valuesArray[0]) {
        valuesString = valuesString + ' ' + this.$t('mayorIgual') + ' ' + valuesArray[0]
      }
      if (valuesArray[1]) {
        if (valuesString.length > 0) {
          valuesString = valuesString + ' ' + this.$t('y')
        }
        valuesString = valuesString + ' ' + this.$t('menorIgual') + ' ' + valuesArray[1]
      }
      return valuesString
    },
    /*
     * formatea un filtro de tipo lista de valores
     */
    fFormateaValorFiltroLista(valueDesc) {
      let valueDescString = ''
      if (valueDesc.length > 0) {
        for (let i = 0; i < valueDesc.length; i++) {
          const value = valueDesc[i]
          valueDescString += value + ', '
        }
      }
      valueDescString = valueDescString.substring(0, valueDescString.length - 2)
      return valueDescString
    }

  }
}
</script>

<style>
.buttonBar .card__title {
  padding: 8px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Informes/Presupuestos/ShpListado.vue